<template>
  <div class="form-row">

    <button type="button" class="btn btn-sm btn-secondary rounded-pill" v-if="checkboxType ==='checkbox-step'"
            data-toggle="modal"
            :data-target="`#modal-${staticGenerateHash}`"
    v-t="`step_manager.feature.inputs.checkbox_step.choose_value_button`"/>


    <teleport to="body">
      <!-- Modal -->
      <div class="modal fade" ref="checkboxStepModal" :id="`modal-${staticGenerateHash}`" tabindex="-1"
           aria-labelledby="exampleModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="text-right" dir="rtl">
                <form @submit.prevent="manageCheckboxStepStatus">
                  <step-options1 ref="checkboxStepOptions" v-model="checkboxStepVariableWatcher"
                                     :options="featureAttributesFirstOptions"/>

                  <button type="submit" class="my-3 btn btn-primary w-100 rounded-pill">ثبت</button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
    </teleport>

    <div class="form-check form-check-inline" :class="[attributeStatus(attribute) ? 'col-12 my-2' : '']"
         v-for="attribute in featureAttributes">


      <div class="" v-if="checkboxType ==='checkbox' ||
      checkboxType ==='checkbox-step' && selectedItems.indexOf(attribute.id) > -1 && findFeatureItem(attribute) != null">
        <button class="btn rounded-pill btn-sm" :class="[attributeStatus(attribute) ? 'btn-danger' : 'btn-primary']"
                @click="manageCheckboxStatus(attribute)">
          {{ buttonText(attribute) }}
        </button>
        <label class="form-check-label mr-2"
               :for="`feature_attribute_${staticGenerateHash}_${attribute.id}`">{{ attribute.value }}</label>
      </div>


      <div v-if="selectedItems.indexOf(attribute.id) > -1 && findFeatureItem(attribute) != null">
        <checkbox-item-image v-if="product.props.featureImagePicker" :attribute="attribute" :product="product"/>

        <feature-item-extra v-if="product.props.accessToFeatureExtra" :product="product"
                            :product-feature="findFeatureItem(attribute)"/>
        <feature-remove-image-button v-if="product.props.featureImagePicker"
                                     :product-feature="findFeatureItem(attribute)" class="my-1"/>
      </div>

    </div>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import CheckboxItemImage from "./CheckboxItemImage.vue";
import FeatureRemoveImageButton from "../../FeatureRemoveImageButton.vue";
import FeatureItemExtra from "../../FeatureItemExtra.vue";
import StepOptions1 from "../StepOptionManager/StepOptions1.vue";
import $ from 'jquery'


export default {
  name: "CheckboxItemConfig",
  components: {StepOptions1, FeatureItemExtra, FeatureRemoveImageButton, CheckboxItemImage},
  props: {
    productFeature: {},
    product: {}
  },
  data() {
    return {
      selectedItems: [],
      checkboxStepVariableWatcher: null,
      selectedCheckboxStepValue: null
    }
  },
  computed: {
    featureAttributes() {
      return this.firstFeatureAttribute.feature.feature_attributes
    },
    staticGenerateHash() {
      return this.generateHash()
    },
    firstFeatureAttribute() {
      return this.productFeature[0]
    },
    checkboxType() {
      return this.firstFeatureAttribute.feature.type
    },
    featureAttributesFirstOptions() {

      const groups = {};
      this.featureAttributes.forEach((attribute) => {
        const values = attribute.value.split(":");
        const firstValue = values[0];
        if (Object.keys(groups).indexOf(firstValue) === -1) {
          groups[firstValue] = []
        }
        groups[firstValue].push(attribute)
      });
      return groups;
    },
  },
  methods: {
    generateHash,
    defineSelectedFeatureAttribute() {
      this.selectedItems = []
      this.productFeature.forEach(item => {
        this.selectedItems.push(item.feature_attribute_id)
      })
    },
    removeFeature(attribute) {
      this.product.features.forEach((item, index) => {

        if (item.feature_attribute_id === attribute.id) {

          const form = {
            product_id: this.product.id,
            feature_product: [item.id],
          }

          if (!isNaN(parseFloat(item.id)) && isFinite(item.id)) {
            this.$store.dispatch('Product/deleteProductFeature', form).then(res => {
              this.product.features.splice(index, 1)
            })
          } else {
            this.product.features.splice(index, 1)
          }

        }

      })
    },
    addFeature(attribute) {
      let baseShape = Object.assign({}, this.firstFeatureAttribute)
      delete baseShape['id'];
      baseShape['feature_attribute_id'] = attribute.id
      this.product.features.push(baseShape)
    },
    manageCheckboxStatus(attribute) {
      const checkStatus = this.attributeStatus(attribute)

      if (checkStatus == false) {
        this.addFeature(attribute)
      }
      if (checkStatus) {
        if (this.selectedItems.length > 1) {
          this.removeFeature(attribute)
        } else {
          toast('حداقل یک ایتم باید انتخاب شود', 'حداقل یک ایتم باید انتخاب شود', 'danger');
        }
      }

    },
    findFeatureItem(attribute) {
      let result = null
      this.productFeature.forEach(item => {
        if (item.feature_attribute_id == attribute.id) {
          result = item
        }
      })
      return result
    },
    attributeStatus(attribute) {
      return this.selectedItems.indexOf(attribute.id) > -1
    },
    buttonText(attribute) {
      return this.attributeStatus(attribute) ? 'حذف' : 'انتخاب'
    },
    manageCheckboxStepStatus() {

      if (this.selectedCheckboxStepValue == null) {
        toast('مقدار انتخابی اشتباه است', 'مقدار انتخابی اشتباه است', 'danger')
        return false
      }

      // check selected attribute selected before
      let checkAttribute = this.attributeStatus(this.selectedCheckboxStepValue)
      if (checkAttribute == false) {
        $(`#${this.$refs.checkboxStepModal.id}`).modal('hide')

        this.addFeature(this.selectedCheckboxStepValue)
      } else {
        toast('مقدار انتخابی قبلا انتخاب شده است', 'مقدار انتخابی قبلا انتخاب شده است', 'danger')
        return false
      }


    },
    findSelectedOptionsObject(selectedOptionResult) {

      for (const [_, item] of Object.entries(this.featureAttributes)) {
        if (item.value === selectedOptionResult) {
          this.selectedCheckboxStepValue = item
        }
      }

    }
  },
  mounted() {
    this.defineSelectedFeatureAttribute()
  },
  watch: {
    checkboxStepVariableWatcher: {
      handler(oldValue, newValue) {
        if (this.checkboxType === 'checkbox-step') {
          setTimeout(() => {
            let result = []
            // Access the listStepOptions ref
            const listStepOptions = this.$refs.checkboxStepOptions;

            // Get all select box values inside it
            if (listStepOptions) {
              const selectBoxes = listStepOptions.$el.querySelectorAll('.list-step-options-select');
              selectBoxes.forEach(selectBox => {
                result.push(selectBox.value)
              });
              result = result.join(':')
              this.findSelectedOptionsObject(result)
            }
          }, 0)
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>